import { defineStore } from 'pinia';
import { authService } from '@/services/auth.service';

export const useAuthStore = defineStore('auth', {
  state: () => ({
    user: null,
    token: localStorage.getItem('token') || null,
  }),

  getters: {
    isAuthenticated: (state) => !!state.token,
    currentUser: (state) => state.user,
  },

  actions: {
    async login(email, password) {
      try {
        const response = await authService.login(email, password);
        if (response.token) {
          this.token = response.token;
          localStorage.setItem('token', response.token);
          await this.fetchUser();
          return { success: true };
        }
        return { success: false, error: 'Invalid credentials' };
      } catch (error) {
        return { success: false, error: error.message };
      }
    },

    async fetchUser() {
      try {
        const userData = await authService.getMe();
        this.user = userData;
        return { success: true };
      } catch (error) {
        return { success: false, error: error.message };
      }
    },

    async logout() {
      this.user = null;
      this.token = null;
      localStorage.removeItem('token');
    },
  },
}); 